import Vue from 'vue';

export const ScrollRevealer = {
	inserted: function (el, binding) {
		const scroll = function (evt) {
			if (binding.value(evt, el)) {
				window.removeEventListener('scroll', scroll);
			}
		};
		window.addEventListener('scroll', scroll);
	},
};

Vue.directive('scroll-revealer', ScrollRevealer);
